/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type Parsable, type ParseNode, type SerializationWriter } from '@microsoft/kiota-abstractions';

export interface BaseCollectionPaginationCountResponse extends Parsable {
    /**
     * The OdataNextLink property
     */
    odataNextLink?: string | null;
}
export interface CharacteristicDto extends Parsable {
    /**
     * The characteristicGroup property
     */
    characteristicGroup?: CharacteristicGroupDto | null;
    /**
     * The characteristicGroupCode property
     */
    characteristicGroupCode?: number | null;
    /**
     * The characteristicValues property
     */
    characteristicValues?: CharacteristicValueDto[] | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The isImmutable property
     */
    isImmutable?: boolean | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The productCharacteristics property
     */
    productCharacteristics?: ProductCharacteristicDto[] | null;
    /**
     * The regulatoryCharacteristics property
     */
    regulatoryCharacteristics?: RegulatoryCharacteristicDto[] | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface CharacteristicGroupDto extends Parsable {
    /**
     * The characteristics property
     */
    characteristics?: CharacteristicDto[] | null;
    /**
     * The code property
     */
    code?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface CharacteristicValueDto extends Parsable {
    /**
     * The characteristic property
     */
    characteristic?: CharacteristicDto | null;
    /**
     * The characteristicCode property
     */
    characteristicCode?: string | null;
    /**
     * The characteristicValueCode property
     */
    characteristicValueCode?: string | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The productCharacteristics property
     */
    productCharacteristics?: ProductCharacteristicDto[] | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface CoolingRegimeGenusDto extends Parsable {
    /**
     * The applicationCode property
     */
    applicationCode?: number | null;
    /**
     * The coolingPriorityCodeLongTerm property
     */
    coolingPriorityCodeLongTerm?: number | null;
    /**
     * The coolingPriorityCodeShortTerm property
     */
    coolingPriorityCodeShortTerm?: number | null;
    /**
     * The coolingRegimeGenusId property
     */
    coolingRegimeGenusId?: number | null;
    /**
     * The coolingTemperatureCodeLongTerm property
     */
    coolingTemperatureCodeLongTerm?: number | null;
    /**
     * The coolingTemperatureCodeLongTermDisplacement property
     */
    coolingTemperatureCodeLongTermDisplacement?: number | null;
    /**
     * The coolingTemperatureCodeShortTerm property
     */
    coolingTemperatureCodeShortTerm?: number | null;
    /**
     * The coolingTemperatureCodeShortTermDisplacement property
     */
    coolingTemperatureCodeShortTermDisplacement?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The genus property
     */
    genus?: GenusDto | null;
    /**
     * The genusCode property
     */
    genusCode?: number | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The priorityLongTerm property
     */
    priorityLongTerm?: CoolingRegimePriorityDto | null;
    /**
     * The priorityShortTerm property
     */
    priorityShortTerm?: CoolingRegimePriorityDto | null;
    /**
     * The relativeHumidityIndication property
     */
    relativeHumidityIndication?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The temperatureLongTerm property
     */
    temperatureLongTerm?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureLongTermDisplacement property
     */
    temperatureLongTermDisplacement?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureShortTerm property
     */
    temperatureShortTerm?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureShortTermDisplacement property
     */
    temperatureShortTermDisplacement?: CoolingRegimeTemperatureDto | null;
}
export interface CoolingRegimeGenusDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: CoolingRegimeGenusDto[] | null;
}
export interface CoolingRegimePriorityDto extends Parsable {
    /**
     * The coolingRegimePriorityId property
     */
    coolingRegimePriorityId?: number | null;
    /**
     * The coolingRegimeProductGroups property
     */
    coolingRegimeProductGroups?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The coolingRegimeProductGroups1 property
     */
    coolingRegimeProductGroups1?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
}
export interface CoolingRegimeProductDto extends Parsable {
    /**
     * The applicationCode property
     */
    applicationCode?: number | null;
    /**
     * The coolingPriorityCodeLongTerm property
     */
    coolingPriorityCodeLongTerm?: number | null;
    /**
     * The coolingPriorityCodeShortTerm property
     */
    coolingPriorityCodeShortTerm?: number | null;
    /**
     * The coolingRegimeProductGroupId property
     */
    coolingRegimeProductGroupId?: number | null;
    /**
     * The coolingRegimeProductId property
     */
    coolingRegimeProductId?: number | null;
    /**
     * The coolingTemperatureCodeLongTerm property
     */
    coolingTemperatureCodeLongTerm?: number | null;
    /**
     * The coolingTemperatureCodeLongTermDisplacement property
     */
    coolingTemperatureCodeLongTermDisplacement?: number | null;
    /**
     * The coolingTemperatureCodeShortTerm property
     */
    coolingTemperatureCodeShortTerm?: number | null;
    /**
     * The coolingTemperatureCodeShortTermDisplacement property
     */
    coolingTemperatureCodeShortTermDisplacement?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The priorityLongTerm property
     */
    priorityLongTerm?: CoolingRegimePriorityDto | null;
    /**
     * The priorityShortTerm property
     */
    priorityShortTerm?: CoolingRegimePriorityDto | null;
    /**
     * The product property
     */
    product?: ProductDto | null;
    /**
     * The productCode property
     */
    productCode?: number | null;
    /**
     * The productGroupCode property
     */
    productGroupCode?: number | null;
    /**
     * The relativeHumidityIndication property
     */
    relativeHumidityIndication?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The temperatureLongTerm property
     */
    temperatureLongTerm?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureLongTermDisplacement property
     */
    temperatureLongTermDisplacement?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureShortTerm property
     */
    temperatureShortTerm?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureShortTermDisplacement property
     */
    temperatureShortTermDisplacement?: CoolingRegimeTemperatureDto | null;
}
export interface CoolingRegimeProductGroupDto extends Parsable {
    /**
     * The applicationCode property
     */
    applicationCode?: number | null;
    /**
     * The coolingPriorityCodeLongTerm property
     */
    coolingPriorityCodeLongTerm?: number | null;
    /**
     * The coolingPriorityCodeShortTerm property
     */
    coolingPriorityCodeShortTerm?: number | null;
    /**
     * The coolingRegimeProductGroupId property
     */
    coolingRegimeProductGroupId?: number | null;
    /**
     * The coolingTemperatureCodeLongTerm property
     */
    coolingTemperatureCodeLongTerm?: number | null;
    /**
     * The coolingTemperatureCodeLongTermDisplacement property
     */
    coolingTemperatureCodeLongTermDisplacement?: number | null;
    /**
     * The coolingTemperatureCodeShortTerm property
     */
    coolingTemperatureCodeShortTerm?: number | null;
    /**
     * The coolingTemperatureCodeShortTermDisplacement property
     */
    coolingTemperatureCodeShortTermDisplacement?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The priorityLongTerm property
     */
    priorityLongTerm?: CoolingRegimePriorityDto | null;
    /**
     * The priorityShortTerm property
     */
    priorityShortTerm?: CoolingRegimePriorityDto | null;
    /**
     * The productGroup property
     */
    productGroup?: ProductGroupDto | null;
    /**
     * The productGroupCode property
     */
    productGroupCode?: number | null;
    /**
     * The relativeHumidityIndication property
     */
    relativeHumidityIndication?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The temperatureLongTerm property
     */
    temperatureLongTerm?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureLongTermDisplacement property
     */
    temperatureLongTermDisplacement?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureShortTerm property
     */
    temperatureShortTerm?: CoolingRegimeTemperatureDto | null;
    /**
     * The temperatureShortTermDisplacement property
     */
    temperatureShortTermDisplacement?: CoolingRegimeTemperatureDto | null;
}
export interface CoolingRegimeProductGroupDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: CoolingRegimeProductGroupDto[] | null;
}
export interface CoolingRegimeTemperatureDto extends Parsable {
    /**
     * The coolingRegimeProductGroups property
     */
    coolingRegimeProductGroups?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The coolingRegimeProductGroups1 property
     */
    coolingRegimeProductGroups1?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The coolingRegimeProductGroups2 property
     */
    coolingRegimeProductGroups2?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The coolingRegimeProductGroups3 property
     */
    coolingRegimeProductGroups3?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The coolingRegimeTemperatureId property
     */
    coolingRegimeTemperatureId?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BaseCollectionPaginationCountResponse}
 */
// @ts-ignore
export function createBaseCollectionPaginationCountResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBaseCollectionPaginationCountResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CharacteristicDto}
 */
// @ts-ignore
export function createCharacteristicDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharacteristicDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CharacteristicGroupDto}
 */
// @ts-ignore
export function createCharacteristicGroupDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharacteristicGroupDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CharacteristicValueDto}
 */
// @ts-ignore
export function createCharacteristicValueDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharacteristicValueDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimeGenusDtoCollectionResponse}
 */
// @ts-ignore
export function createCoolingRegimeGenusDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimeGenusDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimeGenusDto}
 */
// @ts-ignore
export function createCoolingRegimeGenusDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimeGenusDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimePriorityDto}
 */
// @ts-ignore
export function createCoolingRegimePriorityDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimePriorityDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimeProductDto}
 */
// @ts-ignore
export function createCoolingRegimeProductDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimeProductDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimeProductGroupDtoCollectionResponse}
 */
// @ts-ignore
export function createCoolingRegimeProductGroupDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimeProductGroupDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimeProductGroupDto}
 */
// @ts-ignore
export function createCoolingRegimeProductGroupDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimeProductGroupDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CoolingRegimeTemperatureDto}
 */
// @ts-ignore
export function createCoolingRegimeTemperatureDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCoolingRegimeTemperatureDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CropDtoCollectionResponse}
 */
// @ts-ignore
export function createCropDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCropDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CropDto}
 */
// @ts-ignore
export function createCropDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCropDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CultivarDto}
 */
// @ts-ignore
export function createCultivarDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCultivarDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EntityNamingDto}
 */
// @ts-ignore
export function createEntityNamingDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEntityNamingDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GenusDtoCollectionResponse}
 */
// @ts-ignore
export function createGenusDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGenusDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GenusDto}
 */
// @ts-ignore
export function createGenusDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGenusDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductAdministrationDtoCollectionResponse}
 */
// @ts-ignore
export function createProductAdministrationDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductAdministrationDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductAdministrationDto}
 */
// @ts-ignore
export function createProductAdministrationDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductAdministrationDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductCharacteristicDto}
 */
// @ts-ignore
export function createProductCharacteristicDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductCharacteristicDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductDtoCollectionResponse}
 */
// @ts-ignore
export function createProductDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductDto}
 */
// @ts-ignore
export function createProductDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductGroupDtoCollectionResponse}
 */
// @ts-ignore
export function createProductGroupDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductGroupDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductGroupDto}
 */
// @ts-ignore
export function createProductGroupDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductGroupDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RegulatoryCharacteristicDto}
 */
// @ts-ignore
export function createRegulatoryCharacteristicDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRegulatoryCharacteristicDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SpeciesDtoCollectionResponse}
 */
// @ts-ignore
export function createSpeciesDtoCollectionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSpeciesDtoCollectionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SpeciesDto}
 */
// @ts-ignore
export function createSpeciesDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSpeciesDto;
}
export interface CropDto extends Parsable {
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The cropId property
     */
    cropId?: number | null;
    /**
     * The cultivar property
     */
    cultivar?: CultivarDto | null;
    /**
     * The cultivarId property
     */
    cultivarId?: number | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The genus property
     */
    genus?: GenusDto | null;
    /**
     * The genusId property
     */
    genusId?: number | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The products property
     */
    products?: ProductDto[] | null;
    /**
     * The registratorId property
     */
    registratorId?: Registrator | null;
    /**
     * The species property
     */
    species?: SpeciesDto | null;
    /**
     * The speciesId property
     */
    speciesId?: number | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The taxonomicNumber property
     */
    taxonomicNumber?: number | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface CropDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: CropDto[] | null;
}
export interface CultivarDto extends Parsable {
    /**
     * The code property
     */
    code?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The crop property
     */
    crop?: CropDto[] | null;
    /**
     * The cultivarId property
     */
    cultivarId?: number | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
/**
 * The deserialization information for the current model
 * @param BaseCollectionPaginationCountResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBaseCollectionPaginationCountResponse(baseCollectionPaginationCountResponse: Partial<BaseCollectionPaginationCountResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "@odata.nextLink": n => { baseCollectionPaginationCountResponse.odataNextLink = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CharacteristicDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharacteristicDto(characteristicDto: Partial<CharacteristicDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "characteristicGroup": n => { characteristicDto.characteristicGroup = n.getObjectValue<CharacteristicGroupDto>(createCharacteristicGroupDtoFromDiscriminatorValue); },
        "characteristicGroupCode": n => { characteristicDto.characteristicGroupCode = n.getNumberValue(); },
        "characteristicValues": n => { characteristicDto.characteristicValues = n.getCollectionOfObjectValues<CharacteristicValueDto>(createCharacteristicValueDtoFromDiscriminatorValue); },
        "code": n => { characteristicDto.code = n.getStringValue(); },
        "created": n => { characteristicDto.created = n.getDateValue(); },
        "createdBy": n => { characteristicDto.createdBy = n.getStringValue(); },
        "endDate": n => { characteristicDto.endDate = n.getDateValue(); },
        "isImmutable": n => { characteristicDto.isImmutable = n.getBooleanValue(); },
        "lastModified": n => { characteristicDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { characteristicDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { characteristicDto.name = n.getStringValue(); },
        "productCharacteristics": n => { characteristicDto.productCharacteristics = n.getCollectionOfObjectValues<ProductCharacteristicDto>(createProductCharacteristicDtoFromDiscriminatorValue); },
        "regulatoryCharacteristics": n => { characteristicDto.regulatoryCharacteristics = n.getCollectionOfObjectValues<RegulatoryCharacteristicDto>(createRegulatoryCharacteristicDtoFromDiscriminatorValue); },
        "startDate": n => { characteristicDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { characteristicDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CharacteristicGroupDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharacteristicGroupDto(characteristicGroupDto: Partial<CharacteristicGroupDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "characteristics": n => { characteristicGroupDto.characteristics = n.getCollectionOfObjectValues<CharacteristicDto>(createCharacteristicDtoFromDiscriminatorValue); },
        "code": n => { characteristicGroupDto.code = n.getNumberValue(); },
        "created": n => { characteristicGroupDto.created = n.getDateValue(); },
        "createdBy": n => { characteristicGroupDto.createdBy = n.getStringValue(); },
        "endDate": n => { characteristicGroupDto.endDate = n.getDateValue(); },
        "lastModified": n => { characteristicGroupDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { characteristicGroupDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { characteristicGroupDto.name = n.getStringValue(); },
        "startDate": n => { characteristicGroupDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { characteristicGroupDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CharacteristicValueDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharacteristicValueDto(characteristicValueDto: Partial<CharacteristicValueDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "characteristic": n => { characteristicValueDto.characteristic = n.getObjectValue<CharacteristicDto>(createCharacteristicDtoFromDiscriminatorValue); },
        "characteristicCode": n => { characteristicValueDto.characteristicCode = n.getStringValue(); },
        "characteristicValueCode": n => { characteristicValueDto.characteristicValueCode = n.getStringValue(); },
        "created": n => { characteristicValueDto.created = n.getDateValue(); },
        "createdBy": n => { characteristicValueDto.createdBy = n.getStringValue(); },
        "endDate": n => { characteristicValueDto.endDate = n.getDateValue(); },
        "lastModified": n => { characteristicValueDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { characteristicValueDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { characteristicValueDto.name = n.getStringValue(); },
        "productCharacteristics": n => { characteristicValueDto.productCharacteristics = n.getCollectionOfObjectValues<ProductCharacteristicDto>(createProductCharacteristicDtoFromDiscriminatorValue); },
        "startDate": n => { characteristicValueDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { characteristicValueDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimeGenusDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimeGenusDto(coolingRegimeGenusDto: Partial<CoolingRegimeGenusDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applicationCode": n => { coolingRegimeGenusDto.applicationCode = n.getNumberValue(); },
        "coolingPriorityCodeLongTerm": n => { coolingRegimeGenusDto.coolingPriorityCodeLongTerm = n.getNumberValue(); },
        "coolingPriorityCodeShortTerm": n => { coolingRegimeGenusDto.coolingPriorityCodeShortTerm = n.getNumberValue(); },
        "coolingRegimeGenusId": n => { coolingRegimeGenusDto.coolingRegimeGenusId = n.getNumberValue(); },
        "coolingTemperatureCodeLongTerm": n => { coolingRegimeGenusDto.coolingTemperatureCodeLongTerm = n.getNumberValue(); },
        "coolingTemperatureCodeLongTermDisplacement": n => { coolingRegimeGenusDto.coolingTemperatureCodeLongTermDisplacement = n.getNumberValue(); },
        "coolingTemperatureCodeShortTerm": n => { coolingRegimeGenusDto.coolingTemperatureCodeShortTerm = n.getNumberValue(); },
        "coolingTemperatureCodeShortTermDisplacement": n => { coolingRegimeGenusDto.coolingTemperatureCodeShortTermDisplacement = n.getNumberValue(); },
        "created": n => { coolingRegimeGenusDto.created = n.getDateValue(); },
        "createdBy": n => { coolingRegimeGenusDto.createdBy = n.getStringValue(); },
        "endDate": n => { coolingRegimeGenusDto.endDate = n.getDateValue(); },
        "genus": n => { coolingRegimeGenusDto.genus = n.getObjectValue<GenusDto>(createGenusDtoFromDiscriminatorValue); },
        "genusCode": n => { coolingRegimeGenusDto.genusCode = n.getNumberValue(); },
        "lastModified": n => { coolingRegimeGenusDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { coolingRegimeGenusDto.lastModifiedBy = n.getStringValue(); },
        "priorityLongTerm": n => { coolingRegimeGenusDto.priorityLongTerm = n.getObjectValue<CoolingRegimePriorityDto>(createCoolingRegimePriorityDtoFromDiscriminatorValue); },
        "priorityShortTerm": n => { coolingRegimeGenusDto.priorityShortTerm = n.getObjectValue<CoolingRegimePriorityDto>(createCoolingRegimePriorityDtoFromDiscriminatorValue); },
        "relativeHumidityIndication": n => { coolingRegimeGenusDto.relativeHumidityIndication = n.getStringValue(); },
        "startDate": n => { coolingRegimeGenusDto.startDate = n.getDateValue(); },
        "temperatureLongTerm": n => { coolingRegimeGenusDto.temperatureLongTerm = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureLongTermDisplacement": n => { coolingRegimeGenusDto.temperatureLongTermDisplacement = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureShortTerm": n => { coolingRegimeGenusDto.temperatureShortTerm = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureShortTermDisplacement": n => { coolingRegimeGenusDto.temperatureShortTermDisplacement = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimeGenusDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimeGenusDtoCollectionResponse(coolingRegimeGenusDtoCollectionResponse: Partial<CoolingRegimeGenusDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(coolingRegimeGenusDtoCollectionResponse),
        "value": n => { coolingRegimeGenusDtoCollectionResponse.value = n.getCollectionOfObjectValues<CoolingRegimeGenusDto>(createCoolingRegimeGenusDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimePriorityDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimePriorityDto(coolingRegimePriorityDto: Partial<CoolingRegimePriorityDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "coolingRegimePriorityId": n => { coolingRegimePriorityDto.coolingRegimePriorityId = n.getNumberValue(); },
        "coolingRegimeProductGroups": n => { coolingRegimePriorityDto.coolingRegimeProductGroups = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "coolingRegimeProductGroups1": n => { coolingRegimePriorityDto.coolingRegimeProductGroups1 = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "created": n => { coolingRegimePriorityDto.created = n.getDateValue(); },
        "createdBy": n => { coolingRegimePriorityDto.createdBy = n.getStringValue(); },
        "description": n => { coolingRegimePriorityDto.description = n.getStringValue(); },
        "lastModified": n => { coolingRegimePriorityDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { coolingRegimePriorityDto.lastModifiedBy = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimeProductDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimeProductDto(coolingRegimeProductDto: Partial<CoolingRegimeProductDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applicationCode": n => { coolingRegimeProductDto.applicationCode = n.getNumberValue(); },
        "coolingPriorityCodeLongTerm": n => { coolingRegimeProductDto.coolingPriorityCodeLongTerm = n.getNumberValue(); },
        "coolingPriorityCodeShortTerm": n => { coolingRegimeProductDto.coolingPriorityCodeShortTerm = n.getNumberValue(); },
        "coolingRegimeProductGroupId": n => { coolingRegimeProductDto.coolingRegimeProductGroupId = n.getNumberValue(); },
        "coolingRegimeProductId": n => { coolingRegimeProductDto.coolingRegimeProductId = n.getNumberValue(); },
        "coolingTemperatureCodeLongTerm": n => { coolingRegimeProductDto.coolingTemperatureCodeLongTerm = n.getNumberValue(); },
        "coolingTemperatureCodeLongTermDisplacement": n => { coolingRegimeProductDto.coolingTemperatureCodeLongTermDisplacement = n.getNumberValue(); },
        "coolingTemperatureCodeShortTerm": n => { coolingRegimeProductDto.coolingTemperatureCodeShortTerm = n.getNumberValue(); },
        "coolingTemperatureCodeShortTermDisplacement": n => { coolingRegimeProductDto.coolingTemperatureCodeShortTermDisplacement = n.getNumberValue(); },
        "created": n => { coolingRegimeProductDto.created = n.getDateValue(); },
        "createdBy": n => { coolingRegimeProductDto.createdBy = n.getStringValue(); },
        "endDate": n => { coolingRegimeProductDto.endDate = n.getDateValue(); },
        "lastModified": n => { coolingRegimeProductDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { coolingRegimeProductDto.lastModifiedBy = n.getStringValue(); },
        "priorityLongTerm": n => { coolingRegimeProductDto.priorityLongTerm = n.getObjectValue<CoolingRegimePriorityDto>(createCoolingRegimePriorityDtoFromDiscriminatorValue); },
        "priorityShortTerm": n => { coolingRegimeProductDto.priorityShortTerm = n.getObjectValue<CoolingRegimePriorityDto>(createCoolingRegimePriorityDtoFromDiscriminatorValue); },
        "product": n => { coolingRegimeProductDto.product = n.getObjectValue<ProductDto>(createProductDtoFromDiscriminatorValue); },
        "productCode": n => { coolingRegimeProductDto.productCode = n.getNumberValue(); },
        "productGroupCode": n => { coolingRegimeProductDto.productGroupCode = n.getNumberValue(); },
        "relativeHumidityIndication": n => { coolingRegimeProductDto.relativeHumidityIndication = n.getStringValue(); },
        "startDate": n => { coolingRegimeProductDto.startDate = n.getDateValue(); },
        "temperatureLongTerm": n => { coolingRegimeProductDto.temperatureLongTerm = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureLongTermDisplacement": n => { coolingRegimeProductDto.temperatureLongTermDisplacement = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureShortTerm": n => { coolingRegimeProductDto.temperatureShortTerm = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureShortTermDisplacement": n => { coolingRegimeProductDto.temperatureShortTermDisplacement = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimeProductGroupDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimeProductGroupDto(coolingRegimeProductGroupDto: Partial<CoolingRegimeProductGroupDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applicationCode": n => { coolingRegimeProductGroupDto.applicationCode = n.getNumberValue(); },
        "coolingPriorityCodeLongTerm": n => { coolingRegimeProductGroupDto.coolingPriorityCodeLongTerm = n.getNumberValue(); },
        "coolingPriorityCodeShortTerm": n => { coolingRegimeProductGroupDto.coolingPriorityCodeShortTerm = n.getNumberValue(); },
        "coolingRegimeProductGroupId": n => { coolingRegimeProductGroupDto.coolingRegimeProductGroupId = n.getNumberValue(); },
        "coolingTemperatureCodeLongTerm": n => { coolingRegimeProductGroupDto.coolingTemperatureCodeLongTerm = n.getNumberValue(); },
        "coolingTemperatureCodeLongTermDisplacement": n => { coolingRegimeProductGroupDto.coolingTemperatureCodeLongTermDisplacement = n.getNumberValue(); },
        "coolingTemperatureCodeShortTerm": n => { coolingRegimeProductGroupDto.coolingTemperatureCodeShortTerm = n.getNumberValue(); },
        "coolingTemperatureCodeShortTermDisplacement": n => { coolingRegimeProductGroupDto.coolingTemperatureCodeShortTermDisplacement = n.getNumberValue(); },
        "created": n => { coolingRegimeProductGroupDto.created = n.getDateValue(); },
        "createdBy": n => { coolingRegimeProductGroupDto.createdBy = n.getStringValue(); },
        "endDate": n => { coolingRegimeProductGroupDto.endDate = n.getDateValue(); },
        "lastModified": n => { coolingRegimeProductGroupDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { coolingRegimeProductGroupDto.lastModifiedBy = n.getStringValue(); },
        "priorityLongTerm": n => { coolingRegimeProductGroupDto.priorityLongTerm = n.getObjectValue<CoolingRegimePriorityDto>(createCoolingRegimePriorityDtoFromDiscriminatorValue); },
        "priorityShortTerm": n => { coolingRegimeProductGroupDto.priorityShortTerm = n.getObjectValue<CoolingRegimePriorityDto>(createCoolingRegimePriorityDtoFromDiscriminatorValue); },
        "productGroup": n => { coolingRegimeProductGroupDto.productGroup = n.getObjectValue<ProductGroupDto>(createProductGroupDtoFromDiscriminatorValue); },
        "productGroupCode": n => { coolingRegimeProductGroupDto.productGroupCode = n.getNumberValue(); },
        "relativeHumidityIndication": n => { coolingRegimeProductGroupDto.relativeHumidityIndication = n.getStringValue(); },
        "startDate": n => { coolingRegimeProductGroupDto.startDate = n.getDateValue(); },
        "temperatureLongTerm": n => { coolingRegimeProductGroupDto.temperatureLongTerm = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureLongTermDisplacement": n => { coolingRegimeProductGroupDto.temperatureLongTermDisplacement = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureShortTerm": n => { coolingRegimeProductGroupDto.temperatureShortTerm = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
        "temperatureShortTermDisplacement": n => { coolingRegimeProductGroupDto.temperatureShortTermDisplacement = n.getObjectValue<CoolingRegimeTemperatureDto>(createCoolingRegimeTemperatureDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimeProductGroupDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimeProductGroupDtoCollectionResponse(coolingRegimeProductGroupDtoCollectionResponse: Partial<CoolingRegimeProductGroupDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(coolingRegimeProductGroupDtoCollectionResponse),
        "value": n => { coolingRegimeProductGroupDtoCollectionResponse.value = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CoolingRegimeTemperatureDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCoolingRegimeTemperatureDto(coolingRegimeTemperatureDto: Partial<CoolingRegimeTemperatureDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "coolingRegimeProductGroups": n => { coolingRegimeTemperatureDto.coolingRegimeProductGroups = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "coolingRegimeProductGroups1": n => { coolingRegimeTemperatureDto.coolingRegimeProductGroups1 = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "coolingRegimeProductGroups2": n => { coolingRegimeTemperatureDto.coolingRegimeProductGroups2 = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "coolingRegimeProductGroups3": n => { coolingRegimeTemperatureDto.coolingRegimeProductGroups3 = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "coolingRegimeTemperatureId": n => { coolingRegimeTemperatureDto.coolingRegimeTemperatureId = n.getNumberValue(); },
        "created": n => { coolingRegimeTemperatureDto.created = n.getDateValue(); },
        "createdBy": n => { coolingRegimeTemperatureDto.createdBy = n.getStringValue(); },
        "description": n => { coolingRegimeTemperatureDto.description = n.getStringValue(); },
        "lastModified": n => { coolingRegimeTemperatureDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { coolingRegimeTemperatureDto.lastModifiedBy = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CropDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCropDto(cropDto: Partial<CropDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "created": n => { cropDto.created = n.getDateValue(); },
        "createdBy": n => { cropDto.createdBy = n.getStringValue(); },
        "cropId": n => { cropDto.cropId = n.getNumberValue(); },
        "cultivar": n => { cropDto.cultivar = n.getObjectValue<CultivarDto>(createCultivarDtoFromDiscriminatorValue); },
        "cultivarId": n => { cropDto.cultivarId = n.getNumberValue(); },
        "endDate": n => { cropDto.endDate = n.getDateValue(); },
        "genus": n => { cropDto.genus = n.getObjectValue<GenusDto>(createGenusDtoFromDiscriminatorValue); },
        "genusId": n => { cropDto.genusId = n.getNumberValue(); },
        "lastModified": n => { cropDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { cropDto.lastModifiedBy = n.getStringValue(); },
        "products": n => { cropDto.products = n.getCollectionOfObjectValues<ProductDto>(createProductDtoFromDiscriminatorValue); },
        "registratorId": n => { cropDto.registratorId = n.getEnumValue<Registrator>(RegistratorObject); },
        "species": n => { cropDto.species = n.getObjectValue<SpeciesDto>(createSpeciesDtoFromDiscriminatorValue); },
        "speciesId": n => { cropDto.speciesId = n.getNumberValue(); },
        "startDate": n => { cropDto.startDate = n.getDateValue(); },
        "taxonomicNumber": n => { cropDto.taxonomicNumber = n.getNumberValue(); },
        "vbnChangeDateTime": n => { cropDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CropDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCropDtoCollectionResponse(cropDtoCollectionResponse: Partial<CropDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(cropDtoCollectionResponse),
        "value": n => { cropDtoCollectionResponse.value = n.getCollectionOfObjectValues<CropDto>(createCropDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CultivarDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCultivarDto(cultivarDto: Partial<CultivarDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { cultivarDto.code = n.getNumberValue(); },
        "created": n => { cultivarDto.created = n.getDateValue(); },
        "createdBy": n => { cultivarDto.createdBy = n.getStringValue(); },
        "crop": n => { cultivarDto.crop = n.getCollectionOfObjectValues<CropDto>(createCropDtoFromDiscriminatorValue); },
        "cultivarId": n => { cultivarDto.cultivarId = n.getNumberValue(); },
        "endDate": n => { cultivarDto.endDate = n.getDateValue(); },
        "lastModified": n => { cultivarDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { cultivarDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { cultivarDto.name = n.getStringValue(); },
        "startDate": n => { cultivarDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { cultivarDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param EntityNamingDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEntityNamingDto(entityNamingDto: Partial<EntityNamingDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { entityNamingDto.endDate = n.getDateValue(); },
        "itemCode": n => { entityNamingDto.itemCode = n.getStringValue(); },
        "languageCode": n => { entityNamingDto.languageCode = n.getStringValue(); },
        "nameType": n => { entityNamingDto.nameType = n.getStringValue(); },
        "secondItemCode": n => { entityNamingDto.secondItemCode = n.getStringValue(); },
        "startDate": n => { entityNamingDto.startDate = n.getDateValue(); },
        "value": n => { entityNamingDto.value = n.getStringValue(); },
        "vbnChangeDateTime": n => { entityNamingDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param GenusDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGenusDto(genusDto: Partial<GenusDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { genusDto.code = n.getNumberValue(); },
        "coolingRegimeGenus": n => { genusDto.coolingRegimeGenus = n.getCollectionOfObjectValues<CoolingRegimeGenusDto>(createCoolingRegimeGenusDtoFromDiscriminatorValue); },
        "created": n => { genusDto.created = n.getDateValue(); },
        "createdBy": n => { genusDto.createdBy = n.getStringValue(); },
        "crop": n => { genusDto.crop = n.getCollectionOfObjectValues<CropDto>(createCropDtoFromDiscriminatorValue); },
        "endDate": n => { genusDto.endDate = n.getDateValue(); },
        "genusId": n => { genusDto.genusId = n.getNumberValue(); },
        "hasCoolingRegime": n => { genusDto.hasCoolingRegime = n.getBooleanValue(); },
        "lastModified": n => { genusDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { genusDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { genusDto.name = n.getStringValue(); },
        "species": n => { genusDto.species = n.getCollectionOfObjectValues<SpeciesDto>(createSpeciesDtoFromDiscriminatorValue); },
        "startDate": n => { genusDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { genusDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param GenusDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGenusDtoCollectionResponse(genusDtoCollectionResponse: Partial<GenusDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(genusDtoCollectionResponse),
        "value": n => { genusDtoCollectionResponse.value = n.getCollectionOfObjectValues<GenusDto>(createGenusDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductAdministrationDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductAdministrationDto(productAdministrationDto: Partial<ProductAdministrationDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "expired": n => { productAdministrationDto.expired = n.getBooleanValue(); },
        "hasPrimaryCharacteristic": n => { productAdministrationDto.hasPrimaryCharacteristic = n.getBooleanValue(); },
        "productCode": n => { productAdministrationDto.productCode = n.getNumberValue(); },
        "productEndDate": n => { productAdministrationDto.productEndDate = n.getDateValue(); },
        "productGroupCode": n => { productAdministrationDto.productGroupCode = n.getNumberValue(); },
        "productGroupName": n => { productAdministrationDto.productGroupName = n.getStringValue(); },
        "productName": n => { productAdministrationDto.productName = n.getStringValue(); },
        "productStartDate": n => { productAdministrationDto.productStartDate = n.getDateValue(); },
        "registratorCode": n => { productAdministrationDto.registratorCode = n.getEnumValue<Registrator>(RegistratorObject); },
        "taxonomicNumber": n => { productAdministrationDto.taxonomicNumber = n.getNumberValue(); },
        "vbnModifiedDate": n => { productAdministrationDto.vbnModifiedDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductAdministrationDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductAdministrationDtoCollectionResponse(productAdministrationDtoCollectionResponse: Partial<ProductAdministrationDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(productAdministrationDtoCollectionResponse),
        "value": n => { productAdministrationDtoCollectionResponse.value = n.getCollectionOfObjectValues<ProductAdministrationDto>(createProductAdministrationDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductCharacteristicDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductCharacteristicDto(productCharacteristicDto: Partial<ProductCharacteristicDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "characteristic": n => { productCharacteristicDto.characteristic = n.getObjectValue<CharacteristicDto>(createCharacteristicDtoFromDiscriminatorValue); },
        "characteristicCode": n => { productCharacteristicDto.characteristicCode = n.getStringValue(); },
        "characteristicValue": n => { productCharacteristicDto.characteristicValue = n.getObjectValue<CharacteristicValueDto>(createCharacteristicValueDtoFromDiscriminatorValue); },
        "characteristicValueCode": n => { productCharacteristicDto.characteristicValueCode = n.getStringValue(); },
        "created": n => { productCharacteristicDto.created = n.getDateValue(); },
        "createdBy": n => { productCharacteristicDto.createdBy = n.getStringValue(); },
        "endDate": n => { productCharacteristicDto.endDate = n.getDateValue(); },
        "lastModified": n => { productCharacteristicDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { productCharacteristicDto.lastModifiedBy = n.getStringValue(); },
        "product": n => { productCharacteristicDto.product = n.getObjectValue<ProductDto>(createProductDtoFromDiscriminatorValue); },
        "productCode": n => { productCharacteristicDto.productCode = n.getNumberValue(); },
        "startDate": n => { productCharacteristicDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { productCharacteristicDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductDto(productDto: Partial<ProductDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "coolingRegimeProductGroups": n => { productDto.coolingRegimeProductGroups = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "coolingRegimeProducts": n => { productDto.coolingRegimeProducts = n.getCollectionOfObjectValues<CoolingRegimeProductDto>(createCoolingRegimeProductDtoFromDiscriminatorValue); },
        "created": n => { productDto.created = n.getDateValue(); },
        "createdBy": n => { productDto.createdBy = n.getStringValue(); },
        "crop": n => { productDto.crop = n.getObjectValue<CropDto>(createCropDtoFromDiscriminatorValue); },
        "endDate": n => { productDto.endDate = n.getDateValue(); },
        "entityNamings": n => { productDto.entityNamings = n.getCollectionOfObjectValues<EntityNamingDto>(createEntityNamingDtoFromDiscriminatorValue); },
        "lastModified": n => { productDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { productDto.lastModifiedBy = n.getStringValue(); },
        "productCharacteristics": n => { productDto.productCharacteristics = n.getCollectionOfObjectValues<ProductCharacteristicDto>(createProductCharacteristicDtoFromDiscriminatorValue); },
        "productCode": n => { productDto.productCode = n.getNumberValue(); },
        "productGroup": n => { productDto.productGroup = n.getObjectValue<ProductGroupDto>(createProductGroupDtoFromDiscriminatorValue); },
        "productGroupCode": n => { productDto.productGroupCode = n.getNumberValue(); },
        "productName": n => { productDto.productName = n.getStringValue(); },
        "regulatoryCharacteristics": n => { productDto.regulatoryCharacteristics = n.getCollectionOfObjectValues<RegulatoryCharacteristicDto>(createRegulatoryCharacteristicDtoFromDiscriminatorValue); },
        "startDate": n => { productDto.startDate = n.getDateValue(); },
        "taxonomicNumber": n => { productDto.taxonomicNumber = n.getNumberValue(); },
        "toepassing": n => { productDto.toepassing = n.getStringValue(); },
        "vbnChangeDateTime": n => { productDto.vbnChangeDateTime = n.getDateValue(); },
        "vbnProductName": n => { productDto.vbnProductName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductDtoCollectionResponse(productDtoCollectionResponse: Partial<ProductDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(productDtoCollectionResponse),
        "value": n => { productDtoCollectionResponse.value = n.getCollectionOfObjectValues<ProductDto>(createProductDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductGroupDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductGroupDto(productGroupDto: Partial<ProductGroupDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { productGroupDto.code = n.getNumberValue(); },
        "coolingRegimeProductGroups": n => { productGroupDto.coolingRegimeProductGroups = n.getCollectionOfObjectValues<CoolingRegimeProductGroupDto>(createCoolingRegimeProductGroupDtoFromDiscriminatorValue); },
        "created": n => { productGroupDto.created = n.getDateValue(); },
        "createdBy": n => { productGroupDto.createdBy = n.getStringValue(); },
        "endDate": n => { productGroupDto.endDate = n.getDateValue(); },
        "lastModified": n => { productGroupDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { productGroupDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { productGroupDto.name = n.getStringValue(); },
        "products": n => { productGroupDto.products = n.getCollectionOfObjectValues<ProductDto>(createProductDtoFromDiscriminatorValue); },
        "startDate": n => { productGroupDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { productGroupDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProductGroupDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductGroupDtoCollectionResponse(productGroupDtoCollectionResponse: Partial<ProductGroupDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(productGroupDtoCollectionResponse),
        "value": n => { productGroupDtoCollectionResponse.value = n.getCollectionOfObjectValues<ProductGroupDto>(createProductGroupDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param RegulatoryCharacteristicDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRegulatoryCharacteristicDto(regulatoryCharacteristicDto: Partial<RegulatoryCharacteristicDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "characteristic": n => { regulatoryCharacteristicDto.characteristic = n.getObjectValue<CharacteristicDto>(createCharacteristicDtoFromDiscriminatorValue); },
        "characteristicCode": n => { regulatoryCharacteristicDto.characteristicCode = n.getStringValue(); },
        "created": n => { regulatoryCharacteristicDto.created = n.getDateValue(); },
        "createdBy": n => { regulatoryCharacteristicDto.createdBy = n.getStringValue(); },
        "endDate": n => { regulatoryCharacteristicDto.endDate = n.getDateValue(); },
        "isPrimaryCharacteristic": n => { regulatoryCharacteristicDto.isPrimaryCharacteristic = n.getBooleanValue(); },
        "lastModified": n => { regulatoryCharacteristicDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { regulatoryCharacteristicDto.lastModifiedBy = n.getStringValue(); },
        "presentationOrder": n => { regulatoryCharacteristicDto.presentationOrder = n.getNumberValue(); },
        "product": n => { regulatoryCharacteristicDto.product = n.getObjectValue<ProductDto>(createProductDtoFromDiscriminatorValue); },
        "productCode": n => { regulatoryCharacteristicDto.productCode = n.getNumberValue(); },
        "regulationTypeCode": n => { regulatoryCharacteristicDto.regulationTypeCode = n.getEnumValue<RegulationTypes>(RegulationTypesObject); },
        "startDate": n => { regulatoryCharacteristicDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { regulatoryCharacteristicDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SpeciesDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSpeciesDto(speciesDto: Partial<SpeciesDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { speciesDto.code = n.getNumberValue(); },
        "created": n => { speciesDto.created = n.getDateValue(); },
        "createdBy": n => { speciesDto.createdBy = n.getStringValue(); },
        "crops": n => { speciesDto.crops = n.getCollectionOfObjectValues<CropDto>(createCropDtoFromDiscriminatorValue); },
        "endDate": n => { speciesDto.endDate = n.getDateValue(); },
        "genus": n => { speciesDto.genus = n.getObjectValue<GenusDto>(createGenusDtoFromDiscriminatorValue); },
        "genusId": n => { speciesDto.genusId = n.getNumberValue(); },
        "lastModified": n => { speciesDto.lastModified = n.getDateValue(); },
        "lastModifiedBy": n => { speciesDto.lastModifiedBy = n.getStringValue(); },
        "name": n => { speciesDto.name = n.getStringValue(); },
        "speciesId": n => { speciesDto.speciesId = n.getNumberValue(); },
        "startDate": n => { speciesDto.startDate = n.getDateValue(); },
        "vbnChangeDateTime": n => { speciesDto.vbnChangeDateTime = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SpeciesDtoCollectionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSpeciesDtoCollectionResponse(speciesDtoCollectionResponse: Partial<SpeciesDtoCollectionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseCollectionPaginationCountResponse(speciesDtoCollectionResponse),
        "value": n => { speciesDtoCollectionResponse.value = n.getCollectionOfObjectValues<SpeciesDto>(createSpeciesDtoFromDiscriminatorValue); },
    }
}
export interface EntityNamingDto extends Parsable {
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The itemCode property
     */
    itemCode?: string | null;
    /**
     * The languageCode property
     */
    languageCode?: string | null;
    /**
     * The nameType property
     */
    nameType?: string | null;
    /**
     * The secondItemCode property
     */
    secondItemCode?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The value property
     */
    value?: string | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface GenusDto extends Parsable {
    /**
     * The code property
     */
    code?: number | null;
    /**
     * The coolingRegimeGenus property
     */
    coolingRegimeGenus?: CoolingRegimeGenusDto[] | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The crop property
     */
    crop?: CropDto[] | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The genusId property
     */
    genusId?: number | null;
    /**
     * The hasCoolingRegime property
     */
    hasCoolingRegime?: boolean | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The species property
     */
    species?: SpeciesDto[] | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface GenusDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: GenusDto[] | null;
}
export interface ProductAdministrationDto extends Parsable {
    /**
     * The expired property
     */
    expired?: boolean | null;
    /**
     * The hasPrimaryCharacteristic property
     */
    hasPrimaryCharacteristic?: boolean | null;
    /**
     * The productCode property
     */
    productCode?: number | null;
    /**
     * The productEndDate property
     */
    productEndDate?: Date | null;
    /**
     * The productGroupCode property
     */
    productGroupCode?: number | null;
    /**
     * The productGroupName property
     */
    productGroupName?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The productStartDate property
     */
    productStartDate?: Date | null;
    /**
     * The registratorCode property
     */
    registratorCode?: Registrator | null;
    /**
     * The taxonomicNumber property
     */
    taxonomicNumber?: number | null;
    /**
     * The vbnModifiedDate property
     */
    vbnModifiedDate?: Date | null;
}
export interface ProductAdministrationDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: ProductAdministrationDto[] | null;
}
export interface ProductCharacteristicDto extends Parsable {
    /**
     * The characteristic property
     */
    characteristic?: CharacteristicDto | null;
    /**
     * The characteristicCode property
     */
    characteristicCode?: string | null;
    /**
     * The characteristicValue property
     */
    characteristicValue?: CharacteristicValueDto | null;
    /**
     * The characteristicValueCode property
     */
    characteristicValueCode?: string | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The product property
     */
    product?: ProductDto | null;
    /**
     * The productCode property
     */
    productCode?: number | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface ProductDto extends Parsable {
    /**
     * The coolingRegimeProductGroups property
     */
    coolingRegimeProductGroups?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The coolingRegimeProducts property
     */
    coolingRegimeProducts?: CoolingRegimeProductDto[] | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The crop property
     */
    crop?: CropDto | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The entityNamings property
     */
    entityNamings?: EntityNamingDto[] | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The productCharacteristics property
     */
    productCharacteristics?: ProductCharacteristicDto[] | null;
    /**
     * The productCode property
     */
    productCode?: number | null;
    /**
     * The productGroup property
     */
    productGroup?: ProductGroupDto | null;
    /**
     * The productGroupCode property
     */
    productGroupCode?: number | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The regulatoryCharacteristics property
     */
    regulatoryCharacteristics?: RegulatoryCharacteristicDto[] | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The taxonomicNumber property
     */
    taxonomicNumber?: number | null;
    /**
     * The toepassing property
     */
    toepassing?: string | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
    /**
     * The vbnProductName property
     */
    vbnProductName?: string | null;
}
export interface ProductDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: ProductDto[] | null;
}
export interface ProductGroupDto extends Parsable {
    /**
     * The code property
     */
    code?: number | null;
    /**
     * The coolingRegimeProductGroups property
     */
    coolingRegimeProductGroups?: CoolingRegimeProductGroupDto[] | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The products property
     */
    products?: ProductDto[] | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface ProductGroupDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: ProductGroupDto[] | null;
}
export type Registrator = (typeof RegistratorObject)[keyof typeof RegistratorObject];
export type RegulationTypes = (typeof RegulationTypesObject)[keyof typeof RegulationTypesObject];
export interface RegulatoryCharacteristicDto extends Parsable {
    /**
     * The characteristic property
     */
    characteristic?: CharacteristicDto | null;
    /**
     * The characteristicCode property
     */
    characteristicCode?: string | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The isPrimaryCharacteristic property
     */
    isPrimaryCharacteristic?: boolean | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The presentationOrder property
     */
    presentationOrder?: number | null;
    /**
     * The product property
     */
    product?: ProductDto | null;
    /**
     * The productCode property
     */
    productCode?: number | null;
    /**
     * The regulationTypeCode property
     */
    regulationTypeCode?: RegulationTypes | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
/**
 * Serializes information the current object
 * @param BaseCollectionPaginationCountResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBaseCollectionPaginationCountResponse(writer: SerializationWriter, baseCollectionPaginationCountResponse: Partial<BaseCollectionPaginationCountResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!baseCollectionPaginationCountResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("@odata.nextLink", baseCollectionPaginationCountResponse.odataNextLink);
}
/**
 * Serializes information the current object
 * @param CharacteristicDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharacteristicDto(writer: SerializationWriter, characteristicDto: Partial<CharacteristicDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!characteristicDto || isSerializingDerivedType) { return; }
    writer.writeObjectValue<CharacteristicGroupDto>("characteristicGroup", characteristicDto.characteristicGroup, serializeCharacteristicGroupDto);
    writer.writeNumberValue("characteristicGroupCode", characteristicDto.characteristicGroupCode);
    writer.writeCollectionOfObjectValues<CharacteristicValueDto>("characteristicValues", characteristicDto.characteristicValues, serializeCharacteristicValueDto);
    writer.writeStringValue("code", characteristicDto.code);
    writer.writeDateValue("created", characteristicDto.created);
    writer.writeStringValue("createdBy", characteristicDto.createdBy);
    writer.writeDateValue("endDate", characteristicDto.endDate);
    writer.writeBooleanValue("isImmutable", characteristicDto.isImmutable);
    writer.writeDateValue("lastModified", characteristicDto.lastModified);
    writer.writeStringValue("lastModifiedBy", characteristicDto.lastModifiedBy);
    writer.writeStringValue("name", characteristicDto.name);
    writer.writeCollectionOfObjectValues<ProductCharacteristicDto>("productCharacteristics", characteristicDto.productCharacteristics, serializeProductCharacteristicDto);
    writer.writeCollectionOfObjectValues<RegulatoryCharacteristicDto>("regulatoryCharacteristics", characteristicDto.regulatoryCharacteristics, serializeRegulatoryCharacteristicDto);
    writer.writeDateValue("startDate", characteristicDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", characteristicDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param CharacteristicGroupDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharacteristicGroupDto(writer: SerializationWriter, characteristicGroupDto: Partial<CharacteristicGroupDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!characteristicGroupDto || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<CharacteristicDto>("characteristics", characteristicGroupDto.characteristics, serializeCharacteristicDto);
    writer.writeNumberValue("code", characteristicGroupDto.code);
    writer.writeDateValue("created", characteristicGroupDto.created);
    writer.writeStringValue("createdBy", characteristicGroupDto.createdBy);
    writer.writeDateValue("endDate", characteristicGroupDto.endDate);
    writer.writeDateValue("lastModified", characteristicGroupDto.lastModified);
    writer.writeStringValue("lastModifiedBy", characteristicGroupDto.lastModifiedBy);
    writer.writeStringValue("name", characteristicGroupDto.name);
    writer.writeDateValue("startDate", characteristicGroupDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", characteristicGroupDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param CharacteristicValueDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharacteristicValueDto(writer: SerializationWriter, characteristicValueDto: Partial<CharacteristicValueDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!characteristicValueDto || isSerializingDerivedType) { return; }
    writer.writeObjectValue<CharacteristicDto>("characteristic", characteristicValueDto.characteristic, serializeCharacteristicDto);
    writer.writeStringValue("characteristicCode", characteristicValueDto.characteristicCode);
    writer.writeStringValue("characteristicValueCode", characteristicValueDto.characteristicValueCode);
    writer.writeDateValue("created", characteristicValueDto.created);
    writer.writeStringValue("createdBy", characteristicValueDto.createdBy);
    writer.writeDateValue("endDate", characteristicValueDto.endDate);
    writer.writeDateValue("lastModified", characteristicValueDto.lastModified);
    writer.writeStringValue("lastModifiedBy", characteristicValueDto.lastModifiedBy);
    writer.writeStringValue("name", characteristicValueDto.name);
    writer.writeCollectionOfObjectValues<ProductCharacteristicDto>("productCharacteristics", characteristicValueDto.productCharacteristics, serializeProductCharacteristicDto);
    writer.writeDateValue("startDate", characteristicValueDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", characteristicValueDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param CoolingRegimeGenusDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimeGenusDto(writer: SerializationWriter, coolingRegimeGenusDto: Partial<CoolingRegimeGenusDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimeGenusDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("applicationCode", coolingRegimeGenusDto.applicationCode);
    writer.writeNumberValue("coolingPriorityCodeLongTerm", coolingRegimeGenusDto.coolingPriorityCodeLongTerm);
    writer.writeNumberValue("coolingPriorityCodeShortTerm", coolingRegimeGenusDto.coolingPriorityCodeShortTerm);
    writer.writeNumberValue("coolingRegimeGenusId", coolingRegimeGenusDto.coolingRegimeGenusId);
    writer.writeNumberValue("coolingTemperatureCodeLongTerm", coolingRegimeGenusDto.coolingTemperatureCodeLongTerm);
    writer.writeNumberValue("coolingTemperatureCodeLongTermDisplacement", coolingRegimeGenusDto.coolingTemperatureCodeLongTermDisplacement);
    writer.writeNumberValue("coolingTemperatureCodeShortTerm", coolingRegimeGenusDto.coolingTemperatureCodeShortTerm);
    writer.writeNumberValue("coolingTemperatureCodeShortTermDisplacement", coolingRegimeGenusDto.coolingTemperatureCodeShortTermDisplacement);
    writer.writeDateValue("created", coolingRegimeGenusDto.created);
    writer.writeStringValue("createdBy", coolingRegimeGenusDto.createdBy);
    writer.writeDateValue("endDate", coolingRegimeGenusDto.endDate);
    writer.writeObjectValue<GenusDto>("genus", coolingRegimeGenusDto.genus, serializeGenusDto);
    writer.writeNumberValue("genusCode", coolingRegimeGenusDto.genusCode);
    writer.writeDateValue("lastModified", coolingRegimeGenusDto.lastModified);
    writer.writeStringValue("lastModifiedBy", coolingRegimeGenusDto.lastModifiedBy);
    writer.writeObjectValue<CoolingRegimePriorityDto>("priorityLongTerm", coolingRegimeGenusDto.priorityLongTerm, serializeCoolingRegimePriorityDto);
    writer.writeObjectValue<CoolingRegimePriorityDto>("priorityShortTerm", coolingRegimeGenusDto.priorityShortTerm, serializeCoolingRegimePriorityDto);
    writer.writeStringValue("relativeHumidityIndication", coolingRegimeGenusDto.relativeHumidityIndication);
    writer.writeDateValue("startDate", coolingRegimeGenusDto.startDate);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureLongTerm", coolingRegimeGenusDto.temperatureLongTerm, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureLongTermDisplacement", coolingRegimeGenusDto.temperatureLongTermDisplacement, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureShortTerm", coolingRegimeGenusDto.temperatureShortTerm, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureShortTermDisplacement", coolingRegimeGenusDto.temperatureShortTermDisplacement, serializeCoolingRegimeTemperatureDto);
}
/**
 * Serializes information the current object
 * @param CoolingRegimeGenusDtoCollectionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimeGenusDtoCollectionResponse(writer: SerializationWriter, coolingRegimeGenusDtoCollectionResponse: Partial<CoolingRegimeGenusDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimeGenusDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, coolingRegimeGenusDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<CoolingRegimeGenusDto>("value", coolingRegimeGenusDtoCollectionResponse.value, serializeCoolingRegimeGenusDto);
}
/**
 * Serializes information the current object
 * @param CoolingRegimePriorityDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimePriorityDto(writer: SerializationWriter, coolingRegimePriorityDto: Partial<CoolingRegimePriorityDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimePriorityDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("coolingRegimePriorityId", coolingRegimePriorityDto.coolingRegimePriorityId);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups", coolingRegimePriorityDto.coolingRegimeProductGroups, serializeCoolingRegimeProductGroupDto);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups1", coolingRegimePriorityDto.coolingRegimeProductGroups1, serializeCoolingRegimeProductGroupDto);
    writer.writeDateValue("created", coolingRegimePriorityDto.created);
    writer.writeStringValue("createdBy", coolingRegimePriorityDto.createdBy);
    writer.writeStringValue("description", coolingRegimePriorityDto.description);
    writer.writeDateValue("lastModified", coolingRegimePriorityDto.lastModified);
    writer.writeStringValue("lastModifiedBy", coolingRegimePriorityDto.lastModifiedBy);
}
/**
 * Serializes information the current object
 * @param CoolingRegimeProductDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimeProductDto(writer: SerializationWriter, coolingRegimeProductDto: Partial<CoolingRegimeProductDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimeProductDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("applicationCode", coolingRegimeProductDto.applicationCode);
    writer.writeNumberValue("coolingPriorityCodeLongTerm", coolingRegimeProductDto.coolingPriorityCodeLongTerm);
    writer.writeNumberValue("coolingPriorityCodeShortTerm", coolingRegimeProductDto.coolingPriorityCodeShortTerm);
    writer.writeNumberValue("coolingRegimeProductGroupId", coolingRegimeProductDto.coolingRegimeProductGroupId);
    writer.writeNumberValue("coolingRegimeProductId", coolingRegimeProductDto.coolingRegimeProductId);
    writer.writeNumberValue("coolingTemperatureCodeLongTerm", coolingRegimeProductDto.coolingTemperatureCodeLongTerm);
    writer.writeNumberValue("coolingTemperatureCodeLongTermDisplacement", coolingRegimeProductDto.coolingTemperatureCodeLongTermDisplacement);
    writer.writeNumberValue("coolingTemperatureCodeShortTerm", coolingRegimeProductDto.coolingTemperatureCodeShortTerm);
    writer.writeNumberValue("coolingTemperatureCodeShortTermDisplacement", coolingRegimeProductDto.coolingTemperatureCodeShortTermDisplacement);
    writer.writeDateValue("created", coolingRegimeProductDto.created);
    writer.writeStringValue("createdBy", coolingRegimeProductDto.createdBy);
    writer.writeDateValue("endDate", coolingRegimeProductDto.endDate);
    writer.writeDateValue("lastModified", coolingRegimeProductDto.lastModified);
    writer.writeStringValue("lastModifiedBy", coolingRegimeProductDto.lastModifiedBy);
    writer.writeObjectValue<CoolingRegimePriorityDto>("priorityLongTerm", coolingRegimeProductDto.priorityLongTerm, serializeCoolingRegimePriorityDto);
    writer.writeObjectValue<CoolingRegimePriorityDto>("priorityShortTerm", coolingRegimeProductDto.priorityShortTerm, serializeCoolingRegimePriorityDto);
    writer.writeObjectValue<ProductDto>("product", coolingRegimeProductDto.product, serializeProductDto);
    writer.writeNumberValue("productCode", coolingRegimeProductDto.productCode);
    writer.writeNumberValue("productGroupCode", coolingRegimeProductDto.productGroupCode);
    writer.writeStringValue("relativeHumidityIndication", coolingRegimeProductDto.relativeHumidityIndication);
    writer.writeDateValue("startDate", coolingRegimeProductDto.startDate);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureLongTerm", coolingRegimeProductDto.temperatureLongTerm, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureLongTermDisplacement", coolingRegimeProductDto.temperatureLongTermDisplacement, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureShortTerm", coolingRegimeProductDto.temperatureShortTerm, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureShortTermDisplacement", coolingRegimeProductDto.temperatureShortTermDisplacement, serializeCoolingRegimeTemperatureDto);
}
/**
 * Serializes information the current object
 * @param CoolingRegimeProductGroupDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimeProductGroupDto(writer: SerializationWriter, coolingRegimeProductGroupDto: Partial<CoolingRegimeProductGroupDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimeProductGroupDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("applicationCode", coolingRegimeProductGroupDto.applicationCode);
    writer.writeNumberValue("coolingPriorityCodeLongTerm", coolingRegimeProductGroupDto.coolingPriorityCodeLongTerm);
    writer.writeNumberValue("coolingPriorityCodeShortTerm", coolingRegimeProductGroupDto.coolingPriorityCodeShortTerm);
    writer.writeNumberValue("coolingRegimeProductGroupId", coolingRegimeProductGroupDto.coolingRegimeProductGroupId);
    writer.writeNumberValue("coolingTemperatureCodeLongTerm", coolingRegimeProductGroupDto.coolingTemperatureCodeLongTerm);
    writer.writeNumberValue("coolingTemperatureCodeLongTermDisplacement", coolingRegimeProductGroupDto.coolingTemperatureCodeLongTermDisplacement);
    writer.writeNumberValue("coolingTemperatureCodeShortTerm", coolingRegimeProductGroupDto.coolingTemperatureCodeShortTerm);
    writer.writeNumberValue("coolingTemperatureCodeShortTermDisplacement", coolingRegimeProductGroupDto.coolingTemperatureCodeShortTermDisplacement);
    writer.writeDateValue("created", coolingRegimeProductGroupDto.created);
    writer.writeStringValue("createdBy", coolingRegimeProductGroupDto.createdBy);
    writer.writeDateValue("endDate", coolingRegimeProductGroupDto.endDate);
    writer.writeDateValue("lastModified", coolingRegimeProductGroupDto.lastModified);
    writer.writeStringValue("lastModifiedBy", coolingRegimeProductGroupDto.lastModifiedBy);
    writer.writeObjectValue<CoolingRegimePriorityDto>("priorityLongTerm", coolingRegimeProductGroupDto.priorityLongTerm, serializeCoolingRegimePriorityDto);
    writer.writeObjectValue<CoolingRegimePriorityDto>("priorityShortTerm", coolingRegimeProductGroupDto.priorityShortTerm, serializeCoolingRegimePriorityDto);
    writer.writeObjectValue<ProductGroupDto>("productGroup", coolingRegimeProductGroupDto.productGroup, serializeProductGroupDto);
    writer.writeNumberValue("productGroupCode", coolingRegimeProductGroupDto.productGroupCode);
    writer.writeStringValue("relativeHumidityIndication", coolingRegimeProductGroupDto.relativeHumidityIndication);
    writer.writeDateValue("startDate", coolingRegimeProductGroupDto.startDate);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureLongTerm", coolingRegimeProductGroupDto.temperatureLongTerm, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureLongTermDisplacement", coolingRegimeProductGroupDto.temperatureLongTermDisplacement, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureShortTerm", coolingRegimeProductGroupDto.temperatureShortTerm, serializeCoolingRegimeTemperatureDto);
    writer.writeObjectValue<CoolingRegimeTemperatureDto>("temperatureShortTermDisplacement", coolingRegimeProductGroupDto.temperatureShortTermDisplacement, serializeCoolingRegimeTemperatureDto);
}
/**
 * Serializes information the current object
 * @param CoolingRegimeProductGroupDtoCollectionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimeProductGroupDtoCollectionResponse(writer: SerializationWriter, coolingRegimeProductGroupDtoCollectionResponse: Partial<CoolingRegimeProductGroupDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimeProductGroupDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, coolingRegimeProductGroupDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("value", coolingRegimeProductGroupDtoCollectionResponse.value, serializeCoolingRegimeProductGroupDto);
}
/**
 * Serializes information the current object
 * @param CoolingRegimeTemperatureDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCoolingRegimeTemperatureDto(writer: SerializationWriter, coolingRegimeTemperatureDto: Partial<CoolingRegimeTemperatureDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!coolingRegimeTemperatureDto || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups", coolingRegimeTemperatureDto.coolingRegimeProductGroups, serializeCoolingRegimeProductGroupDto);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups1", coolingRegimeTemperatureDto.coolingRegimeProductGroups1, serializeCoolingRegimeProductGroupDto);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups2", coolingRegimeTemperatureDto.coolingRegimeProductGroups2, serializeCoolingRegimeProductGroupDto);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups3", coolingRegimeTemperatureDto.coolingRegimeProductGroups3, serializeCoolingRegimeProductGroupDto);
    writer.writeNumberValue("coolingRegimeTemperatureId", coolingRegimeTemperatureDto.coolingRegimeTemperatureId);
    writer.writeDateValue("created", coolingRegimeTemperatureDto.created);
    writer.writeStringValue("createdBy", coolingRegimeTemperatureDto.createdBy);
    writer.writeStringValue("description", coolingRegimeTemperatureDto.description);
    writer.writeDateValue("lastModified", coolingRegimeTemperatureDto.lastModified);
    writer.writeStringValue("lastModifiedBy", coolingRegimeTemperatureDto.lastModifiedBy);
}
/**
 * Serializes information the current object
 * @param CropDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCropDto(writer: SerializationWriter, cropDto: Partial<CropDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!cropDto || isSerializingDerivedType) { return; }
    writer.writeDateValue("created", cropDto.created);
    writer.writeStringValue("createdBy", cropDto.createdBy);
    writer.writeNumberValue("cropId", cropDto.cropId);
    writer.writeObjectValue<CultivarDto>("cultivar", cropDto.cultivar, serializeCultivarDto);
    writer.writeNumberValue("cultivarId", cropDto.cultivarId);
    writer.writeDateValue("endDate", cropDto.endDate);
    writer.writeObjectValue<GenusDto>("genus", cropDto.genus, serializeGenusDto);
    writer.writeNumberValue("genusId", cropDto.genusId);
    writer.writeDateValue("lastModified", cropDto.lastModified);
    writer.writeStringValue("lastModifiedBy", cropDto.lastModifiedBy);
    writer.writeCollectionOfObjectValues<ProductDto>("products", cropDto.products, serializeProductDto);
    writer.writeEnumValue<Registrator>("registratorId", cropDto.registratorId);
    writer.writeObjectValue<SpeciesDto>("species", cropDto.species, serializeSpeciesDto);
    writer.writeNumberValue("speciesId", cropDto.speciesId);
    writer.writeDateValue("startDate", cropDto.startDate);
    writer.writeNumberValue("taxonomicNumber", cropDto.taxonomicNumber);
    writer.writeDateValue("vbnChangeDateTime", cropDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param CropDtoCollectionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCropDtoCollectionResponse(writer: SerializationWriter, cropDtoCollectionResponse: Partial<CropDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!cropDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, cropDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<CropDto>("value", cropDtoCollectionResponse.value, serializeCropDto);
}
/**
 * Serializes information the current object
 * @param CultivarDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCultivarDto(writer: SerializationWriter, cultivarDto: Partial<CultivarDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!cultivarDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("code", cultivarDto.code);
    writer.writeDateValue("created", cultivarDto.created);
    writer.writeStringValue("createdBy", cultivarDto.createdBy);
    writer.writeCollectionOfObjectValues<CropDto>("crop", cultivarDto.crop, serializeCropDto);
    writer.writeNumberValue("cultivarId", cultivarDto.cultivarId);
    writer.writeDateValue("endDate", cultivarDto.endDate);
    writer.writeDateValue("lastModified", cultivarDto.lastModified);
    writer.writeStringValue("lastModifiedBy", cultivarDto.lastModifiedBy);
    writer.writeStringValue("name", cultivarDto.name);
    writer.writeDateValue("startDate", cultivarDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", cultivarDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param EntityNamingDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEntityNamingDto(writer: SerializationWriter, entityNamingDto: Partial<EntityNamingDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!entityNamingDto || isSerializingDerivedType) { return; }
    writer.writeDateValue("endDate", entityNamingDto.endDate);
    writer.writeStringValue("itemCode", entityNamingDto.itemCode);
    writer.writeStringValue("languageCode", entityNamingDto.languageCode);
    writer.writeStringValue("nameType", entityNamingDto.nameType);
    writer.writeStringValue("secondItemCode", entityNamingDto.secondItemCode);
    writer.writeDateValue("startDate", entityNamingDto.startDate);
    writer.writeStringValue("value", entityNamingDto.value);
    writer.writeDateValue("vbnChangeDateTime", entityNamingDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param GenusDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGenusDto(writer: SerializationWriter, genusDto: Partial<GenusDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!genusDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("code", genusDto.code);
    writer.writeCollectionOfObjectValues<CoolingRegimeGenusDto>("coolingRegimeGenus", genusDto.coolingRegimeGenus, serializeCoolingRegimeGenusDto);
    writer.writeDateValue("created", genusDto.created);
    writer.writeStringValue("createdBy", genusDto.createdBy);
    writer.writeCollectionOfObjectValues<CropDto>("crop", genusDto.crop, serializeCropDto);
    writer.writeDateValue("endDate", genusDto.endDate);
    writer.writeNumberValue("genusId", genusDto.genusId);
    writer.writeBooleanValue("hasCoolingRegime", genusDto.hasCoolingRegime);
    writer.writeDateValue("lastModified", genusDto.lastModified);
    writer.writeStringValue("lastModifiedBy", genusDto.lastModifiedBy);
    writer.writeStringValue("name", genusDto.name);
    writer.writeCollectionOfObjectValues<SpeciesDto>("species", genusDto.species, serializeSpeciesDto);
    writer.writeDateValue("startDate", genusDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", genusDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param GenusDtoCollectionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGenusDtoCollectionResponse(writer: SerializationWriter, genusDtoCollectionResponse: Partial<GenusDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!genusDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, genusDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<GenusDto>("value", genusDtoCollectionResponse.value, serializeGenusDto);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductAdministrationDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductAdministrationDto(writer: SerializationWriter, productAdministrationDto: Partial<ProductAdministrationDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productAdministrationDto || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("expired", productAdministrationDto.expired);
    writer.writeBooleanValue("hasPrimaryCharacteristic", productAdministrationDto.hasPrimaryCharacteristic);
    writer.writeNumberValue("productCode", productAdministrationDto.productCode);
    writer.writeDateValue("productEndDate", productAdministrationDto.productEndDate);
    writer.writeNumberValue("productGroupCode", productAdministrationDto.productGroupCode);
    writer.writeStringValue("productGroupName", productAdministrationDto.productGroupName);
    writer.writeStringValue("productName", productAdministrationDto.productName);
    writer.writeDateValue("productStartDate", productAdministrationDto.productStartDate);
    writer.writeEnumValue<Registrator>("registratorCode", productAdministrationDto.registratorCode);
    writer.writeNumberValue("taxonomicNumber", productAdministrationDto.taxonomicNumber);
    writer.writeDateValue("vbnModifiedDate", productAdministrationDto.vbnModifiedDate);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductAdministrationDtoCollectionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductAdministrationDtoCollectionResponse(writer: SerializationWriter, productAdministrationDtoCollectionResponse: Partial<ProductAdministrationDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productAdministrationDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, productAdministrationDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<ProductAdministrationDto>("value", productAdministrationDtoCollectionResponse.value, serializeProductAdministrationDto);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductCharacteristicDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductCharacteristicDto(writer: SerializationWriter, productCharacteristicDto: Partial<ProductCharacteristicDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productCharacteristicDto || isSerializingDerivedType) { return; }
    writer.writeObjectValue<CharacteristicDto>("characteristic", productCharacteristicDto.characteristic, serializeCharacteristicDto);
    writer.writeStringValue("characteristicCode", productCharacteristicDto.characteristicCode);
    writer.writeObjectValue<CharacteristicValueDto>("characteristicValue", productCharacteristicDto.characteristicValue, serializeCharacteristicValueDto);
    writer.writeStringValue("characteristicValueCode", productCharacteristicDto.characteristicValueCode);
    writer.writeDateValue("created", productCharacteristicDto.created);
    writer.writeStringValue("createdBy", productCharacteristicDto.createdBy);
    writer.writeDateValue("endDate", productCharacteristicDto.endDate);
    writer.writeDateValue("lastModified", productCharacteristicDto.lastModified);
    writer.writeStringValue("lastModifiedBy", productCharacteristicDto.lastModifiedBy);
    writer.writeObjectValue<ProductDto>("product", productCharacteristicDto.product, serializeProductDto);
    writer.writeNumberValue("productCode", productCharacteristicDto.productCode);
    writer.writeDateValue("startDate", productCharacteristicDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", productCharacteristicDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductDto(writer: SerializationWriter, productDto: Partial<ProductDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productDto || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups", productDto.coolingRegimeProductGroups, serializeCoolingRegimeProductGroupDto);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductDto>("coolingRegimeProducts", productDto.coolingRegimeProducts, serializeCoolingRegimeProductDto);
    writer.writeDateValue("created", productDto.created);
    writer.writeStringValue("createdBy", productDto.createdBy);
    writer.writeObjectValue<CropDto>("crop", productDto.crop, serializeCropDto);
    writer.writeDateValue("endDate", productDto.endDate);
    writer.writeCollectionOfObjectValues<EntityNamingDto>("entityNamings", productDto.entityNamings, serializeEntityNamingDto);
    writer.writeDateValue("lastModified", productDto.lastModified);
    writer.writeStringValue("lastModifiedBy", productDto.lastModifiedBy);
    writer.writeCollectionOfObjectValues<ProductCharacteristicDto>("productCharacteristics", productDto.productCharacteristics, serializeProductCharacteristicDto);
    writer.writeNumberValue("productCode", productDto.productCode);
    writer.writeObjectValue<ProductGroupDto>("productGroup", productDto.productGroup, serializeProductGroupDto);
    writer.writeNumberValue("productGroupCode", productDto.productGroupCode);
    writer.writeStringValue("productName", productDto.productName);
    writer.writeCollectionOfObjectValues<RegulatoryCharacteristicDto>("regulatoryCharacteristics", productDto.regulatoryCharacteristics, serializeRegulatoryCharacteristicDto);
    writer.writeDateValue("startDate", productDto.startDate);
    writer.writeNumberValue("taxonomicNumber", productDto.taxonomicNumber);
    writer.writeStringValue("toepassing", productDto.toepassing);
    writer.writeDateValue("vbnChangeDateTime", productDto.vbnChangeDateTime);
    writer.writeStringValue("vbnProductName", productDto.vbnProductName);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductDtoCollectionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductDtoCollectionResponse(writer: SerializationWriter, productDtoCollectionResponse: Partial<ProductDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, productDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<ProductDto>("value", productDtoCollectionResponse.value, serializeProductDto);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductGroupDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductGroupDto(writer: SerializationWriter, productGroupDto: Partial<ProductGroupDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productGroupDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("code", productGroupDto.code);
    writer.writeCollectionOfObjectValues<CoolingRegimeProductGroupDto>("coolingRegimeProductGroups", productGroupDto.coolingRegimeProductGroups, serializeCoolingRegimeProductGroupDto);
    writer.writeDateValue("created", productGroupDto.created);
    writer.writeStringValue("createdBy", productGroupDto.createdBy);
    writer.writeDateValue("endDate", productGroupDto.endDate);
    writer.writeDateValue("lastModified", productGroupDto.lastModified);
    writer.writeStringValue("lastModifiedBy", productGroupDto.lastModifiedBy);
    writer.writeStringValue("name", productGroupDto.name);
    writer.writeCollectionOfObjectValues<ProductDto>("products", productGroupDto.products, serializeProductDto);
    writer.writeDateValue("startDate", productGroupDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", productGroupDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProductGroupDtoCollectionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductGroupDtoCollectionResponse(writer: SerializationWriter, productGroupDtoCollectionResponse: Partial<ProductGroupDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!productGroupDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, productGroupDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<ProductGroupDto>("value", productGroupDtoCollectionResponse.value, serializeProductGroupDto);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RegulatoryCharacteristicDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRegulatoryCharacteristicDto(writer: SerializationWriter, regulatoryCharacteristicDto: Partial<RegulatoryCharacteristicDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!regulatoryCharacteristicDto || isSerializingDerivedType) { return; }
    writer.writeObjectValue<CharacteristicDto>("characteristic", regulatoryCharacteristicDto.characteristic, serializeCharacteristicDto);
    writer.writeStringValue("characteristicCode", regulatoryCharacteristicDto.characteristicCode);
    writer.writeDateValue("created", regulatoryCharacteristicDto.created);
    writer.writeStringValue("createdBy", regulatoryCharacteristicDto.createdBy);
    writer.writeDateValue("endDate", regulatoryCharacteristicDto.endDate);
    writer.writeBooleanValue("isPrimaryCharacteristic", regulatoryCharacteristicDto.isPrimaryCharacteristic);
    writer.writeDateValue("lastModified", regulatoryCharacteristicDto.lastModified);
    writer.writeStringValue("lastModifiedBy", regulatoryCharacteristicDto.lastModifiedBy);
    writer.writeNumberValue("presentationOrder", regulatoryCharacteristicDto.presentationOrder);
    writer.writeObjectValue<ProductDto>("product", regulatoryCharacteristicDto.product, serializeProductDto);
    writer.writeNumberValue("productCode", regulatoryCharacteristicDto.productCode);
    writer.writeEnumValue<RegulationTypes>("regulationTypeCode", regulatoryCharacteristicDto.regulationTypeCode);
    writer.writeDateValue("startDate", regulatoryCharacteristicDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", regulatoryCharacteristicDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SpeciesDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSpeciesDto(writer: SerializationWriter, speciesDto: Partial<SpeciesDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!speciesDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("code", speciesDto.code);
    writer.writeDateValue("created", speciesDto.created);
    writer.writeStringValue("createdBy", speciesDto.createdBy);
    writer.writeCollectionOfObjectValues<CropDto>("crops", speciesDto.crops, serializeCropDto);
    writer.writeDateValue("endDate", speciesDto.endDate);
    writer.writeObjectValue<GenusDto>("genus", speciesDto.genus, serializeGenusDto);
    writer.writeNumberValue("genusId", speciesDto.genusId);
    writer.writeDateValue("lastModified", speciesDto.lastModified);
    writer.writeStringValue("lastModifiedBy", speciesDto.lastModifiedBy);
    writer.writeStringValue("name", speciesDto.name);
    writer.writeNumberValue("speciesId", speciesDto.speciesId);
    writer.writeDateValue("startDate", speciesDto.startDate);
    writer.writeDateValue("vbnChangeDateTime", speciesDto.vbnChangeDateTime);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SpeciesDtoCollectionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSpeciesDtoCollectionResponse(writer: SerializationWriter, speciesDtoCollectionResponse: Partial<SpeciesDtoCollectionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!speciesDtoCollectionResponse || isSerializingDerivedType) { return; }
    serializeBaseCollectionPaginationCountResponse(writer, speciesDtoCollectionResponse, isSerializingDerivedType)
    writer.writeCollectionOfObjectValues<SpeciesDto>("value", speciesDtoCollectionResponse.value, serializeSpeciesDto);
}
export interface SpeciesDto extends Parsable {
    /**
     * The code property
     */
    code?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The crops property
     */
    crops?: CropDto[] | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The genus property
     */
    genus?: GenusDto | null;
    /**
     * The genusId property
     */
    genusId?: number | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The speciesId property
     */
    speciesId?: number | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The vbnChangeDateTime property
     */
    vbnChangeDateTime?: Date | null;
}
export interface SpeciesDtoCollectionResponse extends BaseCollectionPaginationCountResponse, Parsable {
    /**
     * The value property
     */
    value?: SpeciesDto[] | null;
}
export const RegistratorObject = {
    Vkc: "vkc",
    Varb: "varb",
    Kafb: "kafb",
    Vba: "vba",
} as const;
export const RegulationTypesObject = {
    Verplicht: "verplicht",
    Advies: "advies",
    Toegestaan: "toegestaan",
} as const;
/* tslint:enable */
/* eslint-enable */
